import React, { useMemo } from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import styled from 'styled-components'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

import { useAppSelector } from 'redux/Hook'
import {
  calculateIsChecked,
  getSelectedCurrentRows,
} from './Helpers/BulkSelectHelpers'

const StyledBox = styled(Grid)`
  margin-bottom: 1rem !important;
  border-radius: 0.75rem;
  background: white;
  height: 3.375rem;
`

const BulkSelectionMessage = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { data: currentRows, selectedContributions: selectedRows } =
    useAppSelector((state) => state.textAnalysis)

  const { allSelected, allSelectedCount } = useMemo(
    () => ({
      allSelected: calculateIsChecked(currentRows, selectedRows),
      allSelectedCount: getSelectedCurrentRows(selectedRows, currentRows),
    }),
    [currentRows, selectedRows],
  )

  if (isMobile || !allSelected) {
    return null
  }

  return (
    <StyledBox
      item
      xs={12}
      display="flex"
      alignItems="center"
      justifyContent="center"
      data-testid="ta-bulk-select-message"
    >
      <Typography>
        All {allSelectedCount.length} contributions on this page are selected.
      </Typography>
    </StyledBox>
  )
}

export default React.memo(BulkSelectionMessage)
